import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import Page from '../index'
import AcceptAccountInvite from './AcceptAccountInvite'

import useUserHaveInvites from '../../features/hooks/useUserHaveInvites'

import { getCurrentUserProfile, setUserAccountSetupMode } from '../../modules/actions/app'
import { clearAcceptInvite } from '../../modules/actions/team'

import { getCurrentUserSelector } from '../../modules/selectors/app'
import { inviteWasAcceptedSelector } from '../../modules/selectors/team'

const Invites = () => {
  const dispatch = useDispatch()

  // extra state to manage invite acceptance, when there are multiple invites
  // and we can accept first one, but delete another
  const [someInviteAccepted, setSomeInviteAccepted] = useState(false)

  const { account_invites: accountInvites } = useSelector(getCurrentUserSelector)
  const inviteWasAccepted = useSelector(inviteWasAcceptedSelector)

  const isAnyInviteExist = useUserHaveInvites()

  const firstAccountInvite = accountInvites && accountInvites[0]

  // when there are no invites and at least one was accepted, then reload UserData
  const shouldReloadUserData = !isAnyInviteExist && (someInviteAccepted || inviteWasAccepted)

  // when at least one invite was accepted, we need to re-fetch user data and partnerships
  useEffect(() => {
    if (shouldReloadUserData) {
      dispatch(clearAcceptInvite())
      dispatch(getCurrentUserProfile())
    }
  }, [dispatch, shouldReloadUserData])

  useEffect(() => {
    // turn off userAccountSetupMode once all invites were approved or declined
    if (!isAnyInviteExist) {
      dispatch(setUserAccountSetupMode(false))
    }
  }, [dispatch, isAnyInviteExist])

  const renderPageContent = () => {
    if (isAnyInviteExist && firstAccountInvite) {
      return <AcceptAccountInvite invite={firstAccountInvite} setAtLeastOneInviteAccepted={setSomeInviteAccepted} />
    }

    return null
  }

  return <Page helmetTitle="Invites">{renderPageContent()}</Page>
}

export default Invites
